import { GPTGameNameType } from '../games';
import {
  DailyBonusIcon,
  GPTGameIcon,
  LuckyCardIcon,
  LuckyPigeonIcon,
  WheelOfFortuneIcon
} from '../icons';

export const GPT_BANNERS_CONFIG: Partial<
  Record<GPTGameNameType, { Icon: GPTGameIcon; title: string }>
> = {
  cardGame: {
    Icon: LuckyCardIcon,
    title: 'gptBanners.luckyCardTitle'
  },
  wheelOfFortune: {
    Icon: WheelOfFortuneIcon,
    title: 'gptBanners.wheelOfFortuneTitle'
  },
  dailyBonus: {
    Icon: DailyBonusIcon,
    title: 'gptBanners.dailyBonusTitle'
  },
  birdGame: {
    Icon: LuckyPigeonIcon,
    title: 'gptBanners.luckyPigeonTitle'
  }
};
